import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { toast } from '@/lib/toast'

export function useOrganizations() {
  return useQuery({
    queryKey: ['my-organizations'],
    queryFn: async () => {
      const { data: { session } } = await supabase.auth.getSession()
      if (!session) return []
      const { data, error } = await supabase.from('resident_organizations')
        .select('*').eq('resident_id', session.user.id).order('is_active', { ascending: false }).order('start_date', { ascending: false, nullsFirst: false })
      if (error) throw error
      return data ?? []
    },
  })
}

export function useCreateOrganization() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (input: Record<string, unknown>) => {
      const { data: { session } } = await supabase.auth.getSession()
      if (!session) throw new Error('Not authenticated')
      const { error } = await supabase.from('resident_organizations').insert({ ...input, resident_id: session.user.id })
      if (error) throw error
    },
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['my-organizations'] }); toast.success('Saved') },
    onError: (err: Error) => toast.error(err.message),
  })
}

export function useUpdateOrganization() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async ({ id, ...fields }: Record<string, unknown> & { id: string }) => {
      const { error } = await supabase.from('resident_organizations').update(fields).eq('id', id)
      if (error) throw error
    },
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['my-organizations'] }); toast.success('Saved') },
    onError: (err: Error) => toast.error(err.message),
  })
}

export function useDeleteOrganization() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (id: string) => {
      const { error } = await supabase.from('resident_organizations').delete().eq('id', id)
      if (error) throw error
    },
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['my-organizations'] }); toast.success('Removed') },
    onError: (err: Error) => toast.error(err.message),
  })
}
